import React from 'react';
import Widget from './Widget';
import { Link } from 'react-router-dom';
import Grid from '@mui/material/Grid2';
const Column = ({ column }) => {
    function parseSizeProps(size) {
        const defaultSize = { lg: 6, md: 6, sm: 6, xs: 6 };
        const finalSize = size ?? defaultSize;
        return Object.fromEntries(
            Object.entries(finalSize).map(([key, value]) => [
            key,
            Number.isNaN(parseInt(value, 10)) ? defaultSize[key] : parseInt(value, 10)
            ])
        );
    }
    return (
        <Grid
            size={parseSizeProps(column.props?.size)}
            alignItems={column?.props?.alignItems ?? { xl: 'unset', lg: 'unset', md: 'unset', xs: 'unset' }}
            justifyContent={column?.props?.justifyContent ?? { xl: 'unset', lg: 'unset', md: 'unset', xs: 'unset' }}
            sx={column?.style}
            {...(column.props.href ? { component: Link, to: `${column.props.href}` } : {})}
        >
            <Grid container>
                {column?.widgets?.map((widget) => (
                    <Widget key={widget.id} widget={widget} widgetStyle={widget?.style} widgetProps={widget?.props} />
                ))}
            </Grid>
        </Grid>
    )
}
export default React.memo(Column);